import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { getAllNotifications, type Notification } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useNotifications(): UseQueryResult<Record<string, Notification>, AxiosError> {
    return useQuery({
        queryKey: queryKeys.notifications(),
        queryFn: ({ signal }) => getAllNotifications({ signal }).then((result) => result.data),
    });
}
